import _ from 'lodash'
import { React, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from 'globalStyles'
import { useTranslation } from 'react-i18next'
import DropDown from './DropDown'

const SpanStyled = styled.span`
  font-weight: 600;
  color: ${colors.primary_blue};
`

const DropdownWithDisplay = ({ items, disabled, selectedValueHandler, activePin }) => {
  const [isDisabled] = useState(items.length > 0 ? disabled : true)
  const { t } = useTranslation()

  const spanDivStyle = {
    padding: '0',
    display: 'flex',
    alignItems: 'center',
  }

  const styledSpan = {
    height: '28px',
    marginTop: '-7px',
  }

  return (
    <div className="input-group mb-1" style={styledSpan}>
      <div style={spanDivStyle}>
        <SpanStyled>{`${t('view_package')} ${_.indexOf(items, activePin) + 1} ${t('of')} ${
          items.length
        }`}</SpanStyled>
      </div>
      <DropDown
        items={items}
        onSelectHandler={selectedValueHandler}
        isDisabled={isDisabled}
        value={activePin}
        id="multi-piece-shipment-pins-selector"
      />
    </div>
  )
}

DropdownWithDisplay.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
  selectedValueHandler: PropTypes.func.isRequired,
  activePin: PropTypes.string.isRequired,
}

DropdownWithDisplay.defaultProps = {
  disabled: false,
}

export default DropdownWithDisplay
